export default __webpack_public_path__ + "static/media/AARP.90bb63ae.svg";